import { EventLogDto } from './dtos'
import { BaseCrudService } from './BaseCrudService'
import { PaginatedQueryBase } from './api'
import { PaginatedDto } from './extendedType'
import { axios } from './api'

export type EntityEventLogsFilters = PaginatedQueryBase & {
  entityId?: string
  entityName?: string
}

class EntityEventLogService extends BaseCrudService<
  EventLogDto,
  {},
  {},
  EntityEventLogsFilters
> {
  constructor() {
    super('event-log', process.env.REACT_APP_API_URL)
  }

  override getAll(
    filters: EntityEventLogsFilters,
  ): Promise<PaginatedDto<EventLogDto>> {
    const { entityId, entityName, ...pagination } = filters
    if (!entityId || !entityName) return Promise.resolve({ datas: [], totalCount: 0 })

    return new Promise((resolve, reject) => {
      const configs = this.buildConfig(
        'get',
        `${this.endpoint}/entity/${entityId}`,
        undefined,
        { entityName, ...pagination } as Record<string, unknown>,
      )
      axios(configs, resolve, reject)
    })
  }
}

export const entityEventLogService = new EntityEventLogService()
